import { message } from "antd";
import { BlogService } from "./api";
import { init, success, finish, error } from "services/common";
import { isEmpty } from "lodash";
import { BLOG_MGT_TYPES } from "services/types";

const blogService = new BlogService();

export const managementBlogAdd = (body) => {
  return async (dispatch) => {
    dispatch(init(BLOG_MGT_TYPES.CREATE_BLOG_MGT_MESSAGE));
    const response = await blogService.createManagementBlogMessage(body);
    dispatch(finish(BLOG_MGT_TYPES.CREATE_BLOG_MGT_MESSAGE));
    if (response.isSuccess) {
      message.success("post message");
      dispatch(success(BLOG_MGT_TYPES.CREATE_BLOG_MGT_MESSAGE, response.data));
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};

export const updateManagementBlogMessage = (id, body) => {
  return async (dispatch) => {
    dispatch(init(BLOG_MGT_TYPES.UPDATE_BLOG_MGT_MESSAGE));
    const response = await blogService.updateManagementBlogMessage(id, body);
    dispatch(finish(BLOG_MGT_TYPES.UPDATE_BLOG_MGT_MESSAGE));
    if (response.isSuccess) {
      message.success("update message");
      dispatch(success(BLOG_MGT_TYPES.UPDATE_BLOG_MGT_MESSAGE, response.data));
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
  };
};

export const getManagementBlogPagination = (query, loadMore) => {
  return async (dispatch) => {
    dispatch(init(BLOG_MGT_TYPES.GET_PAGINATION_BLOG_MGT_MESSAGE));
    const response = await blogService.getManagementBlogMessagePagination(
      query
    );
    try {
      if (response.isSuccess) {
        if (loadMore) {
          dispatch(
            success(
              BLOG_MGT_TYPES.GET_PAGINATION_BLOG_MGT_MESSAGE_CHANGE,
              response.data
            )
          );
        } else {
          dispatch(
            success(
              BLOG_MGT_TYPES.GET_PAGINATION_BLOG_MGT_MESSAGE,
              response.data
            )
          );
        }
      } else if (!response.isSuccess) {
        dispatch(error(response.errorMessage));
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(finish(BLOG_MGT_TYPES.GET_PAGINATION_BLOG_MGT_MESSAGE));
    }
  };
};
